// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0ac5953","241":"e484fcb3","322":"67063df6","342":"0d6af621","453":"288c3d22","455":"11e230d0","697":"6669aa81","722":"b607c501","817":"92963b6b"}[chunkId] + ".chunk.js";
};